import { useQuery } from "react-query";
import axios from "axios";
import { getVal } from "oolib";

/**
 * MAD-specific hook: fetches child data options for a dropdown,
 * based on the selected volunteer profile.
 *
 * Block config usage:
 *   plugin: { optionsFetcherFn: "mad_useChildDataOptions" }
 */
export const mad_useChildDataOptions = ({ content, readOnly }) => {
  // Rendered read-only outside a form (the Responses list shows a saved value
  // with no document behind it) there is no document to read the volunteer
  // from, and nothing to fetch.
  const dependentValue = content ? getVal(content, "tags.volunteers") : undefined;
  const dependentId = dependentValue?.data?.[0]?._id;

  const { data, status } = useQuery(
    ["mad_childDataOptions", dependentId],
    () =>
      axios
        .get("/api/pluginRoutes/mad/getChildrenByVolunteer", {
          params: { volunteerProfileId: dependentId },
        })
        .then((res) => res.data.data),
    { enabled: !!dependentId && !readOnly }
  );

  if (!dependentId) return { options: [], status: "no-dependency" };

  if (status === "loading") {
    return {
      options: [{ display: "Loading...", loading: true }],
      status,
    };
  }

  const options =
    data?.map((d) => ({
      display: d.display,
      value: d.value || d.tagId,
      tagId: d.tagId,
    })) || [];

  return { options, status };
};
